import { Database01Icon } from '@langchain/untitled-ui-icons';
import { Input } from '@mui/joy';

import SaveConfirmationModal from '@/components/SaveConfirmationModal';

export const SaveDatasetModal = ({
  open,
  onClose,
  onSave,
  isLoading,
  datasetName,
  setDatasetName,
}: {
  open: boolean;
  onClose: () => void;
  onSave: () => void;
  isLoading: boolean;
  datasetName: string;
  setDatasetName: (name: string) => void;
}) => {
  const disabledSaveTooltip = () => {
    if (isLoading) {
      return 'Saving...';
    }
    if (!datasetName.length) {
      return 'Dataset name is required';
    }
    return undefined;
  };

  return (
    <SaveConfirmationModal
      isOpen={open}
      onClose={onClose}
      onConfirm={onSave}
      title="Save Dataset to Run Experiment"
      description="To run the experiment, you need to save your current work as a new dataset."
      disabledSaveTooltip={disabledSaveTooltip()}
      children={
        <div className="mt-4 flex flex-col gap-2">
          <div className="text-sm font-medium">Dataset Name</div>
          <Input
            placeholder="Enter dataset name"
            value={datasetName}
            onChange={(e) => setDatasetName(e.target.value)}
            startDecorator={<Database01Icon className="h-4 w-4" />}
            size="sm"
          />
        </div>
      }
    />
  );
};
